import { sendMsg, SERVICES_REQUEST, ENDPOINT_REQUEST } from "../../configurations";

export const fundServices = {
  getCashInstructionEnquiry,
  getFundDepositOrderCancel,
  getFundWithdrawalOrderCancel,
  cashDepositService,
  cashWithdrawalService,
  transferService,
  transferEnquiryService,
  queryCurrencyConversionService,
  foreignExchangeService,
  foreignExchangeEnquiryService,
  cashDepositWithdrawalFeeEnquiryService,
  withdrawableBalanceEnquiryService,
  getFundMasterEnquiry,
}

function getCashInstructionEnquiry(params, callback) {
    sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.GET_CASH_INSTRUCTION_ENQUIRY, params).get(res => {
        callback(res);
    })
}
function getFundDepositOrderCancel(params, callback) {
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.CASH_DEPOSIT, params).post(res => {
      callback(res);
  })
}

function getFundWithdrawalOrderCancel(params, callback) {
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.CASH_WITHDRAWAL, params).post(res => {
      callback(res);
  })
}

function cashDepositService(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.CASH_DEPOSIT, params).post(res => {
    callback(res);
  })
}

function cashWithdrawalService(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.CASH_WITHDRAWAL, params).post(res => {
    callback(res);
  })
}

function transferService(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.CAHS_TRANSFER, params).post(res => {
    callback(res);
  })
}

function transferEnquiryService(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.CAHS_TRANSFER_ENQUIRY, params).get(res => {
    callback(res);
  })
}

function queryCurrencyConversionService(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.QUERY_CURRENCY_CONVERSION, params).get(res => {
    callback(res);
  })
}

function foreignExchangeService(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.FOREIGN_EXCHANGE, params).post(res => {
    callback(res);
  })
}

function foreignExchangeEnquiryService(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.FOREIGN_EXCHANGE_ENQUIRY, params).get(res => {
    callback(res);
  })
}

function cashDepositWithdrawalFeeEnquiryService(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.CASH_DEPOSIT_WITHDRAWAL_FEE_ENQUIRY, params).get(res => {
    callback(res);
  })
}

function withdrawableBalanceEnquiryService(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.WITHDRAWABLE_BALANCE_ENQUIRY, params).get(res => {
    callback(res);
  })
}

function getFundMasterEnquiry(params, callback){
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.FUND.GET_MASTER_ENQUIRY, params).get(res => {
    callback(res);
  })
}